module.exports = __webpack_public_path__ + "static/img/redfile1.62d15f2f.png";